// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2gXdj","title":"InfoRow_title__2xBDA"};